import React from "react";
import Grid from "@mui/material/Grid";
import { Box, breakpointValues, customBreakpoints, Typography } from "../../platform-style";

interface LabelValueProp {
  label: string;
  labelMinWidth?: string;
  labelBold?: boolean;
  value: string | null | undefined;
  valueIcon?: React.JSX.Element;
  id?: string;
  gap?: Gap;
  direction?: Direction;
  valueMaxWidth?: string;
  testid?: string;
  colon?: boolean;
}

export type Gap = "space" | "tab";
export type Direction = "column" | "row";

export const LabelValue = ({
  direction = "row",
  gap,
  id,
  label,
  labelMinWidth,
  labelBold = true,
  testid,
  value,
  valueIcon,
  valueMaxWidth,
  colon = true,
}: LabelValueProp) => {
  if (value == null) {
    value = "";
  }
  let internalID: string = label.replace(/\s/g, "");

  function getMinWidth(): string {
    if (gap) {
      if (gap === "space") {
        return " ";
      } else {
        return labelMinWidth ? labelMinWidth : "180px";
      }
    } else {
      return labelMinWidth ? labelMinWidth : "180px";
    }
  }

  const renderComponent = () => {
    return (
      <Grid
        container
        direction={direction ? direction : "row"}
        spacing={direction != "column" ? "4px" : 0}
        data-testid={testid ? testid : undefined}
        flexWrap={"nowrap"}
        sx={{ [customBreakpoints.down(breakpointValues.sm)]: { flexWrap: "wrap" } }}
      >
        <Grid
          item
          minWidth={getMinWidth()}
          role={"rowheader"}
          id={"label" + id}
          sx={{
            fontWeight: labelBold ? "700" : "400",
            paddingTop: direction == "column" ? "4px" : "16px",
          }}
        >
          {direction == "row" ? (
            `${label}:`
          ) : (
            <Typography variant={"labelSmall"}>
              {label}
              {colon ? ":" : ""}
            </Typography>
          )}
        </Grid>
        <Grid
          item
          maxWidth={valueMaxWidth ? valueMaxWidth : "13rem"}
          id={id ? id : "value" + internalID}
          sx={{ paddingTop: direction == "column" ? "4px" : "16px" }}
        >
          <>
            {value ? value : ""}
            {valueIcon != undefined ? (
              <Box component={"span"} sx={{ ml: 1 }} aria-label={"iconSpan"}>
                {valueIcon}
              </Box>
            ) : (
              ""
            )}
          </>
        </Grid>
      </Grid>
    );
  };

  return <>{renderComponent()}</>;
};
